import React, { useEffect, useState, useRef, useCallback } from 'react';
import './ImageFilter.scss'
import { useDispatch, useSelector } from 'react-redux';
import { LibrarySourceType } from './types/ThirdPartyLibrary';
import { FilterDropdown } from './FilterDropdown';
import { fetchSubTiles, setSelectedSource, setUpThirdPartyLibrariesSearch } from './redux/actions';

export const ImageFilter = ({ source , setFiltersToSearch}: { source?: LibrarySourceType, setFiltersToSearch:(val:{filterKey:string, filterValue:string}[])=>void }) => {

    const { imageLibraryFilters } = useSelector((state: any) => state.fbdata) || {};

    const updatedFilters = useSelector(({thirdPartyLibrary}:any)=>thirdPartyLibrary.updatedFilters)

    const dispatch = useDispatch();

    const[filters, setFilters] = useState({}as any)

    const filterSelected = useCallback((key, value, clearAll)=>{
        let updatedFilters:{[key:string]:any} = {}
        if(clearAll){
            for (const key in filters) {
                if (Object.prototype.hasOwnProperty.call(filters, key)) {
                    updatedFilters[key]= undefined
                }
            }
        }else{
            updatedFilters = { ...filters, [key]: value ? value : undefined };
        }
        
        const filtersToSearch:{filterKey:string, filterValue:string}[]=[]
        Object.keys(updatedFilters).forEach(filterKey => {
            const value = updatedFilters[filterKey];
            value && filtersToSearch.push({ filterKey, filterValue: updatedFilters[filterKey] })
        })

        const searchQuery = JSON.stringify(filtersToSearch);

        dispatch(setSelectedSource('ownLibrary_searchResults'))
        dispatch(setUpThirdPartyLibrariesSearch('ownLibrary_searchResults', searchQuery))
        dispatch(fetchSubTiles('ownLibrary_searchResults', {
            id: searchQuery,
            isCategory: true,
            isPatternContainer: true,
            name: searchQuery,
            term: searchQuery,
        }, 0))

        setFilters(updatedFilters)

    },[filters])

    useEffect(()=>{
        return ()=>{filterSelected(null, null, true)}
    },[]);
   
    // useEffect(()=>{
    //     const filtersToSearch:{filterKey:string, filterValue:string}[]=[]
    //     Object.keys(filters).forEach(filterKey=>{
    //         filtersToSearch.push({filterKey, filterValue:filters[filterKey]})
    //     })
    //     filtersToSearch && filtersToSearch.length && setFiltersToSearch(filtersToSearch);

    // },[filters])

    return <div className='image-lib-filter'>
        {
            imageLibraryFilters.map((filter: any) => {
                const options = updatedFilters && updatedFilters[filter.filterKey] && [...updatedFilters[filter.filterKey]]
                return <div key={filter.filterKey}>
                    <FilterDropdown onValueSelected={filterSelected} filterKey={filter.filterKey} placeholder={filter.filterName} list={options || filter.options} />
                </div>
            })
        }
    </div>
}